import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.configuration_api.mp_base_puestos;

const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
}));

export const getAllMpBasePuestos = async () => {
    return await api.get('/GetAllMpBasePuestos');
    }

export const getMpBasePuestosById = async (id: number) => {
    return await api.get(`/GetMpBasePuestosById/${id}`);
    }

    